module.exports = __webpack_public_path__ + "img/confirmation-email-en.14e2e801.png";